import {NgModule} from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {AmplifyAuthenticatorModule} from '@aws-amplify/ui-angular';
import {AuthInterceptor} from './auth.interceptor';
import {RequiresOneOfRolesDirective} from './requires-one-of-roles.directive';
import {RolIconPipe} from './rol-icon.pipe';

@NgModule({
  declarations: [
    RequiresOneOfRolesDirective,
    RolIconPipe,
  ],
  imports: [
    AmplifyAuthenticatorModule,
  ],
  exports: [
    AmplifyAuthenticatorModule,
    RequiresOneOfRolesDirective,
    RolIconPipe,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  ]
})
export class AuthModule {
}
